export const SUPERFICIALFRONTFOREARM = 'SUPERFICIALFRONTFOREARM'
export const DEEPFRONTFOREARM = 'DEEPFRONTFOREARM'
export const SUPERFICIALBACKFOREARM = 'SUPERFICIALBACKFOREARM'
export const DEEPBACKFOREARM = 'DEEPBACKFOREARM'
export const MUSCLETHUMB = 'MUSCLETHUMB'
export const MUSCLEPALM = 'MUSCLEPALM'
export const DEEPMUSCLEPALM = 'DEEPMUSCLEPALM'
export const SELECTEDMUSCLEGROUP = 'SELECTEDMUSCLEGROUP'
export const AllPAUSED = "AllPAUSED"


export const addSuperficialFrontForearmVisibility = data => (
    {
        type: SUPERFICIALFRONTFOREARM,
        payload: data
    }

)
export const addDeepFrontForearmVisibility = data => (
    {
        type: DEEPFRONTFOREARM,
        payload: data
    }

)

export const addSuperficialBackForearmVisibility = data => (
    {
        type: SUPERFICIALBACKFOREARM,
        payload: data
    }

)
export const addDeepBackForearmVisibility = data => (
    {
        type: DEEPBACKFOREARM,
        payload: data
    }

)
export const addMuscleThumbVisibility = data => (
    {
        type: MUSCLETHUMB,
        payload: data
    }

)
export const addMusclePalmVisibility = data => (
    {
        type: MUSCLEPALM,
        payload: data
    }

)
export const addDeepMusclePalm = data => (
    {
        type: DEEPMUSCLEPALM,
        payload: data
    }
)

export const addSelectedMuscleGroup = data => (
    {
        type: SELECTEDMUSCLEGROUP,
        payload: data
    }

)
export const addAllPaused = data => (
    {
        type: AllPAUSED,
        payload: data
    }

)
const initialstate = {
    SuperficialFrontForearmVisibility: {
        pronator_teres: true,
        flexor_carpi_radialis: true,
        palmar_longus_muscle: true,
        flexor_carpi_ulnaris: true,
        flexor_digitorum_super_cialis: true

    },
    DeepFrontForearmVisibility: {
        pronator_quadratus: true,
        flexor_digitorum_profundus: true,
        flexor_pollicis_longus: true,
    },
    SuperficialBackForearmVisibility: {
        extensor_digitorum: true,
        extensor_digiti_minimi: true,
        extensor_carpi_ulnaris: true,
        brachialis_muscle: true,
        extensor_carpi_radialis_longus: true,
        extensor_carpi_radialis_brevis: true,
    },
    DeepBackForearmVisibility: {
        supinator: true,
        extensor_indices: true,
        abductor_pollicis_longus: true,
        extensor_pollicis_brevis: true,
        extensor_pollicis_longus: true,
    },
    MuscleThumbVisibility: {
        opponens_pollicis: true,
        flexor_pollicis_brevis: true,
        abductor_pollicis_brevis: true,
        abductor_pollicis: true,
    },
    MusclePalmVisibility: {
        palmaris_brevis: true,
        abductor_digiti_minimi: true,
        flexor_digiti_minimi_brevis: true,
        opponens_digiti_minimi: true,
    },
    DeepMusclePalmVisibility: {
        lumbricals: true,
        dorsal_interrosei: true,
        palmar_interossei: true,
    },
    SelectedMuscleGroup: {
        superficial_front_forearm: true,
        deep_front_forearm: true,
        superficial_back_forearm: true,
        deep_back_forearm: true,
        muscles_thumb: true,
        muscles_palm: true,
        deep_muscles_palm: true,
    },
    allpaused: true


}
const AreaSelectionModeReducer = (state = initialstate, action) => {
    switch (action.type) {
        case SUPERFICIALFRONTFOREARM:
            return {
                ...state,
                SuperficialFrontForearmVisibility: action.payload
            }
        case DEEPFRONTFOREARM:
            return {
                ...state,
                DeepFrontForearmVisibility: action.payload
            }
        case SUPERFICIALBACKFOREARM:
            return {
                ...state,
                SuperficialBackForearmVisibility: action.payload
            }
        case DEEPBACKFOREARM:
            return {
                ...state,
                DeepBackForearmVisibility: action.payload
            }
        case MUSCLETHUMB:
            return {
                ...state,
                MuscleThumbVisibility: action.payload
            }
        case MUSCLEPALM:
            return {
                ...state,
                MusclePalmVisibility: action.payload
            }
        case DEEPMUSCLEPALM:
            return {
                ...state,
                DeepMusclePalmVisibility: action.payload
            }
        case SELECTEDMUSCLEGROUP:
            return {
                ...state,
                SelectedMuscleGroup: action.payload
            }
        case AllPAUSED:
            return {
                ...state,
                allpaused: action.payload
            }
        default:
            return state;
    }

}
export default AreaSelectionModeReducer